module.exports = __webpack_public_path__ + "img/invitationEnM.a76aac18.jpg";